<div class="header-container">
  <div id="bloc1" class="block1" >
      <span >
        <mat-icon> table_chart</mat-icon>
      </span>
      <span class="hide-text-lebel">
          Polls
      </span>
      
  </div>
  <div id="bloc2" class="block2">
      <input class="search-bar" 
      type="search" 
      aria-label="search" 
      placeholder="Search" 
      [(ngModel)]="searchText"  
      (ngModelChange)="onSearch($event)">
  </div>
  <div id="bloc3" class="block3">
      
  </div>
</div>

<mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>

<div class="mat-elevation-z8" style="padding: 2vw;" [hidden]="showSpinner">
  <div *ngIf="selectedPolls">
    <button mat-raised-button style="height: 2.2rem; margin-bottom: 5px;" (click)="openChangeGroupsforPollDialog()" color="primary" >Update</button>
  </div>
    <table mat-table #table [dataSource]="dataSource" matSort>
    
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef> Select </th>
          <td mat-cell *matCellDef="let row"> 
            <input  type="checkbox" [(ngModel)]="row.selected"
            (change)="onChangeSelect(row)">
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let row"> {{row.name | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="poll_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Poll Type </th>
          <td mat-cell *matCellDef="let row" > {{row.poll_type | titlecase}} </td>
        </ng-container>
    
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef> Message </th>
          <td mat-cell *matCellDef="let row" > {{row.message}} </td>
        </ng-container>

        <ng-container matColumnDef="expiry_time" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiry Time(in mins) </th>
          <td mat-cell *matCellDef="let row"> {{row.expiry_time / 60}}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Modified Date </th>
          <td mat-cell *matCellDef="let row">{{row.updated_at | date:'M/d/yy, h:mm a'}} </td>
        </ng-container>

        <ng-container matColumnDef="id" >
          <th mat-header-cell *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let row"> <mat-icon (click)= "openEditPoll(row)">create</mat-icon> </td>
        </ng-container>

        <ng-container matColumnDef="created_at" >
          <th mat-header-cell *matHeaderCellDef> Execution </th>
          <td mat-cell *matCellDef="let row"> <mat-icon (click)= "navigateToExecute(row.id)">play_circle_outline</mat-icon> </td>
        </ng-container>
    
        <ng-container matColumnDef="adhoc" >
            <th mat-header-cell *matHeaderCellDef> Delete </th>
            <td mat-cell *matCellDef="let row"> <mat-icon (click)="deletePoll(row.id)">delete</mat-icon> </td>
        </ng-container>

        <ng-container matColumnDef="group_id" >
          <th mat-header-cell *matHeaderCellDef> Clone </th>
          <td mat-cell *matCellDef="let row"> <mat-icon (click)="clonePoll(row.id)">file_copy</mat-icon> </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{searchText}}"</td>
        </tr>
    </table>
    
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>

